import { http, HttpResponse } from 'msw';

import { apiRoutes } from '@shared/consts/apiRoutes.ts';
import { userProfileUpdatePayloadFixture } from '@shared/mocks/requests/userProfile/userProfile.fixtures';

export const userProfileRequests = [
  http.put(`*${apiRoutes.putUserProfile(':userProfileId')}`, () => {
    return HttpResponse.json(userProfileUpdatePayloadFixture);
  }),
];
